import React from 'react';
import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';

export const BrandsOverview = lazy(
  () =>
    import('./BrandsOverview.eager').then(mod => ({
      default: mod.BrandsOverview,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
